/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { Modal } from '@zeeve-platform/modal-component';
import { prefixPath } from '../../../utils/helpers';
import BaseUrls from '../../../utils/baseUrls';
import apiBackendInstance from '../../../utils/axios';
import { SlackChannelConfig } from './addCommunicationChannel/slackBody';
import { TeamsChannelConfig } from './addCommunicationChannel/teamsBody';
import EditChannelMainBody from './addCommunicationChannel/editChannelBody';

export type CommunicationChannelTable = {
  id?: string,
  commChannelName?: string,
  commChannel: string,
  ownerId: string,
  organizationId?: string,
  isDefault: boolean,
  isAlertDefault: boolean,
  authInfo?: SlackChannelConfig|TeamsChannelConfig,
}

const CommunicationChannelComponent = () => {
  const [loading, setLoading] = useState(true);
  const [deleteChannelBtn, setDeleteChannel] = useState<boolean>(false);
  const [deleteChannelMsg, setDeleteChannelMsg] = useState('');
  const [modalShow, setModalShow] = useState<boolean>(false);
  const [modelChannelId, setModelChannelId] = useState('' as string | undefined);
  const [editChannelBtn, setEditChannel] = useState<boolean>(false);
  const [editChannelMsg, setEditChannelMsg] = useState('');
  const [editModalShow, setEditModalShow] = useState<boolean>(false);
  const [editModelChannelIndex, setEditModelChannelIndex] = useState<number>(-1);
  const [reloadEffect, setReloadEffect] = useState(false as boolean);

  const theme = BaseUrls.getkey();
  const loaderUrl = window.location.origin + prefixPath(`/img/${theme}/spin.svg`);
  const deleteIcon = `img/${theme}/deleteicon.svg`;
  const editIcon = `img/${theme}/edit.svg`;
  const [communicationChannelOptions, setCommunicationChannelOptions] = useState([
    { name: 'MS Teams', icon: `img/${theme}/microsoft-teams-color.png`, referenceUrl: 'https://learn.microsoft.com/en-us/microsoftteams/platform/webhooks-and-connectors/how-to/add-incoming-webhook' },
    { name: 'Slack', icon: `img/${theme}/slack-color.png`, referenceUrl: 'https://api.slack.com/messaging/webhooks' }] as Array<{name: string, icon: string, referenceUrl: string}>);
  const [userCommunicationChannels, setUserCommunicationChannels] = useState([] as Array<CommunicationChannelTable>);

  const showLoader = () => {
    const spinner = document.getElementById('spinnerDiv');
    if (spinner) spinner.style.display = 'block';
  };
  const hideLoader = () => {
    const spinner = document.getElementById('spinnerDiv');
    if (spinner) spinner.style.display = 'none';
  };

  const loadNewWindow = (channel: string) => {
    const features = 'menubar=yes,location=yes,resizable=no,scrollbars=yes,status=no';
    const toAddCommunicationChannel: string = prefixPath(`/addCommunicationChannel/${channel}`);
    window.open(toAddCommunicationChannel, '_blank', features);
  };

  const callApi = () => {
    showLoader();
    apiBackendInstance.get(BaseUrls.getUserCommunicationChannel(), {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response && response.data && response.data.data) {
        setUserCommunicationChannels(() => ([...response.data.data]));
      }
      hideLoader();
      setLoading(false);
    }).catch(() => {
      setUserCommunicationChannels([]);
      hideLoader();
      setLoading(false);
    });
  };

  const callEditApi = (e: any, idx: number) => {
    const selectedElement: any = document.getElementById(`${e.target.name}${idx}`);
    if (selectedElement) selectedElement.disabled = true;
    const updateUserCommunicationChannel = { ...userCommunicationChannels[idx], [e.target.name]: e.target.checked };
    apiBackendInstance.post(BaseUrls.editUserCommunicationChannel(), updateUserCommunicationChannel).then((response) => {
      hideLoader();
      setLoading(false);
      selectedElement.disabled = false;
      setReloadEffect((prev) => !prev);
    }).catch(() => {
      hideLoader();
      setLoading(false);
      selectedElement.disabled = false;
    });
  };

  const onClickEditHandler = (e: any, idx: number) => {
    console.log(userCommunicationChannels[idx].id);
    setEditModelChannelIndex(idx);
    setEditModalShow(true);
    setEditChannel(true);
  };

  const onClickDeleteHandler = (idx: number) => {
    console.log(userCommunicationChannels[idx].id);
    setModelChannelId(userCommunicationChannels[idx].id);
    setModalShow(true);
    setDeleteChannel(true);
  };
  const commChannelImage = (channel: string) => {
    switch (channel.toLowerCase()) {
      case 'ms teams':
        return `img/${theme}/microsoft-teams-color.png`;
      case 'slack':
        return `img/${theme}/slack-color.png`;
      default:
        return '';
    }
  };
  const confirmEditChannel = async () => {
    showLoader();
    if (!editModelChannelIndex || editModelChannelIndex === -1) {
      hideLoader();
      setLoading(false);
      setEditModalShow(false);
      setEditChannel(false);
    }
    const response: any = await apiBackendInstance.post(BaseUrls.editUserCommunicationChannel(), userCommunicationChannels[editModelChannelIndex]);

    if (response) {
      hideLoader();
      setLoading(false);
      setEditChannel(false);
      if (response.data.success) {
        setEditChannelMsg('Edit Successfully!');
        setReloadEffect((prev) => !prev);
      } else {
        setEditChannelMsg(response.data.message);
      }
    } else {
      setEditChannelMsg('Error on editing Channel!');
      hideLoader();
      setLoading(false);
      setEditChannel(false);
    }
  };

  const confirmDeleteChannel = async () => {
    showLoader();
    if (!modelChannelId || modelChannelId === '') {
      hideLoader();
      setLoading(false);
      setModalShow(false);
      setDeleteChannel(false);
    }
    const response: any = await apiBackendInstance.delete(BaseUrls.deleteUserCommunicationChannel(modelChannelId as string));

    if (response) {
      hideLoader();
      setLoading(false);
      setDeleteChannel(false);
      if (response.data.success) {
        setDeleteChannelMsg('Deleted Successfully!');
        setReloadEffect((prev) => !prev);
      } else {
        setDeleteChannelMsg(response.data.message);
      }
    } else {
      setDeleteChannelMsg('Error Deleting Channel!');
      hideLoader();
      setLoading(false);
      setDeleteChannel(false);
    }
  };
  useEffect(() => {
    callApi();
    const onReceiveMessage = (e:any) => {
      const { key } = e;
      if (key === 'updateChannelState') {
        callApi();
      }
    };
    window.addEventListener('storage', onReceiveMessage);
    return () => {
      window.removeEventListener('storage', onReceiveMessage);
    };
  }, [reloadEffect]);
  return (
    <>
    <div className="col-xl-11 col-lg-12 col-sm-12 col-md-12">
      <div className="col-xl-11 col-lg-12 col-sm-12 col-md-12 text-end">
        <div className="mx-3 mt-4 text-start">
          <h5 className="">Notifications</h5>
          <p>The Notifications feature offered by the Zeeve platform provides users with the capability to seamlessly integrate popular messaging platforms such as Slack and Microsoft Teams.</p>
          <p>By configuring this integration, users can receive real-time updates of all monitoring alerts directly in their preferred messaging channels.</p>
          {communicationChannelOptions.length !== 0 && (<h6>Here is a link to the webhook URL from the respective platforms:</h6>)}
          <div className="d-flex" id="nav-tab-channels dropdown-toggle">
              {communicationChannelOptions.map((channels) => (
                  <button
                  className="btn"
                  type="button"
                  onClick={() => window.open(channels.referenceUrl, '_blank')}
                  style={{ color: 'black', marginRight: '10px', border: '1px solid black' }}
                  >
                    <img src={commChannelImage(channels.name)} alt={channels.name} height="15px" />
                    {' '}
                    <span>{channels.name}</span>
                  </button>
              ))}
          </div>
        </div>
        <div className="btn-group mx-1 mt-3">
          <button
            className="btn btn-primary dropdown-toggle"
            type="button"
            id="communication-channel-options"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Add Channel
          </button>
          <div className="dropdown-menu" aria-labelledby="communication-channel-options">
            {
                communicationChannelOptions && communicationChannelOptions.map((i) => (
                  <div className="d-flex flex-row dropdown-item align-items-center">
                    <img
                      src={i.icon}
                      height="15px"
                      alt=""
                    />
                  <button type="button" className="btn" onClick={() => { loadNewWindow(i.name); }}>{i.name}</button>
                  </div>
                ))
            }
          </div>
        </div>
        {!loading && userCommunicationChannels.length === 0 && (
        <div style={{ color: '#ABB2B9', textAlign: 'center', fontSize: '20px' }}>
          No Data
        </div>
        )}
      {userCommunicationChannels.length > 0
        && (
          <table className="table mt-4 text-center">
            <thead className="head-bg">
              <tr>
                <th className="col-1">Channel Name</th>
                <th className="col-1">Channel</th>
                <th className="col-1">Enable Alert</th>
                <th className="col-1" style={{ display: 'none' }}>All</th>
                <th className="col-1">Action</th>
              </tr>
            </thead>
            <tbody className="tableTextColor ">
              {userCommunicationChannels.length > 0 && userCommunicationChannels.map((d: CommunicationChannelTable, idx) => (
                <tr key={d.id}>
                  <td className="">{d.commChannelName}</td>
                  <td className="">
                    <div>
                      <img src={commChannelImage(d.commChannel)} alt={d.commChannel} height="15px" />
                      {' '}
                      <span>{d.commChannel}</span>
                    </div>
                  </td>
                  <td>
                    <Form.Check
                      type="switch"
                      id={`isAlertDefault${idx}`}
                      name="isAlertDefault"
                      checked={d.isAlertDefault}
                      onChange={(e) => callEditApi(e, idx)}
                    />
                  </td>
                  <td style={{ display: 'none' }}>
                    <Form.Check
                      type="switch"
                      id={`isDefault${idx}`}
                      name="isDefault"
                      checked={d.isDefault}
                      onChange={(e) => callEditApi(e, idx)}
                    />
                  </td>
                  <td className="">
                    <img
                      src={editIcon}
                      height="14px"
                      title="edit Channel"
                      alt=""
                      onClick={(e) => onClickEditHandler(e, idx)}
                    />
                    {' '}
                    <img
                    src={deleteIcon}
                    className=""
                    height="14px"
                    title="delete"
                    alt=""
                    onClick={() => onClickDeleteHandler(idx)}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
    <div
        id="spinnerDiv"
        className="text-center mx-5 p-3 col-11 "
        style={{ display: 'none' }}
    >
        <img className="" style={{ margin: 'auto' }} src={loaderUrl} alt="spinnner" />
    </div>
    <Modal
      show={modalShow}
      onHide={() => setModalShow(false)}
      title="Are you sure you want to delete Channel?"
      visibleFooter
      visibleFooterCloseButton
      visibleHeaderCloseIcon={false}
      visibleConfirmBtn={deleteChannelBtn}
      confirmBtnText="Yes"
      onConfirm={confirmDeleteChannel}
      confirmBtnClassName=""
    >
      <p className="status text-center pt-3">{deleteChannelMsg}</p>
    </Modal>
    <Modal
      show={editModalShow}
      onHide={() => setEditModalShow(false)}
      title=""
      visibleFooter
      visibleFooterCloseButton
      visibleHeaderCloseIcon={false}
      onConfirm={confirmEditChannel}
      confirmBtnClassName=""
    >
      { userCommunicationChannels[editModelChannelIndex]
      && (
<EditChannelMainBody
        id={userCommunicationChannels[editModelChannelIndex].id}
        channel={userCommunicationChannels[editModelChannelIndex].commChannel}
        name={userCommunicationChannels[editModelChannelIndex].commChannelName}
        isAlert={userCommunicationChannels[editModelChannelIndex].isAlertDefault}
        isDefault={userCommunicationChannels[editModelChannelIndex].isDefault}
        ownerId={userCommunicationChannels[editModelChannelIndex].ownerId}
        organizationId={userCommunicationChannels[editModelChannelIndex].organizationId}
        authInfo={userCommunicationChannels[editModelChannelIndex].authInfo}
        onHide={() => setEditModalShow(false)}
        isReload={() => setReloadEffect((prev) => !prev)}
/>
      )}
      <p className="status text-center pt-3">{editChannelMsg}</p>
    </Modal>
    </>
  );
};

export default CommunicationChannelComponent;